import { css } from '@mui/styled-engine'
import { HAVDesignTokensInterface } from '../interfaces'

const havErrorAlert = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-size: ${HAVDesignTokens.typography.font.size.x.small};
  font-family: ${HAVDesignTokens.typography.font.weight.bold};
  line-height: ${HAVDesignTokens.typography.font.size.x.small};

  .MuiSvgIcon-root {
    font-size: ${HAVDesignTokens.icon.size.small};
  }
`

export { havErrorAlert }
